import { useState } from 'react';

type LoadingState = 'idle' | 'loading' | 'success' | 'error';

export const useLoadingState = () => {
  const [isLoading, setIsLoading] = useState<LoadingState>('idle');

  return [isLoading, setIsLoading] as const;
};
